// extracted by mini-css-extract-plugin
module.exports = {"input":"input-module_input"};